export * from './sidenav';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/sidenav/index.js
// module id = 716
// module chunks = 3